import { connect } from 'react-redux';
import Products from './Products';
import { fetchProductsData } from '../../../../store/products/actions';
import { getModals } from '../../../../store/modals/selectors';
import { getProducts } from '../../../../store/products/selectors';
import { deleteContent } from '../../../../store/commons/actions';

const mapStateToProps = (state) => ({
  modals: getModals(state),
  products: getProducts(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchProductsData: (
    filterName,
    filterValue,
  ) => dispatch(
    fetchProductsData(
      filterName,
      filterValue,
    ),
  ),

  deleteContent: (destination) => dispatch(deleteContent(destination)),

});

export default connect(mapStateToProps, mapDispatchToProps)(Products);
